import gql from 'graphql-tag';

export default gql`
  query GetProperty($id: ID!, $role: StakeholderRole, $searchTerm: String) {
    property( id: $id ) {
      createdAt
      id
      code
      updatedAt
      address
      size
      valuation
      suburb
      rooms
      erfNumber
      status
      documents {
        id
        name
        status
        file {
          id
          original
        }
      }
      image {
        id
        scaled
        original
        thumbnail
      }
      type
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/GetProperty.ts